import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLandmarkGlobal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 256,
	height: 204,
	viewBox: "0 0 256 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M148.678 97.1761C100.743 142.831 55.5265 159.873 35.6685 140.21C26.5341 130.237 24.8888 110.236 38.8009 77.3017L15.9453 84.5417C-3.92907 123.865 -4.78079 161.058 10.9151 180.516C42.7759 211.88 116.458 180.122 184.026 113.218C219.09 77.0178 244.217 41.8116 256 12L196.803 29.6031C188.001 49.9034 172.79 71.3579 148.678 97.1761Z",
			fill: "url(#paint0_linear)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M129.797 50.0453C102.399 103.564 59.4545 117.029 49.0221 107.539C42.7759 100.299 43.1326 88.6515 49.7319 74.1786L129.797 50.0453Z",
			fill: "url(#paint1_linear)"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear",
			x1: 120.5,
			y1: 42.5,
			x2: 33.2021,
			y2: 135.675,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E03934" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A31815"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear",
			x1: 120.5,
			y1: 42.5,
			x2: 33.2021,
			y2: 135.675,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E03934" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A31815"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 256,
				height: 204,
				fill: "white"
			})
		})
	] })]
});
export default SvgLandmarkGlobal;
